module.exports = __webpack_public_path__ + "07373a4121e00b93f8d14fee604a41b6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SY.svg
// module id = Ezb4
// module chunks = 0